
import React from "react";
import { NavigationStepsTransdev } from "../../components/navbars/navbar_transdev";
import UserHeader from "../../components/user_header";

const DeclarationsPbTransdev = () => {
  return (
    <>
      <UserHeader />
      <div style={{ padding: "20px", marginTop: "40px" }}>
        <NavigationStepsTransdev selectedKey="declarations_pb_transdev" />
        <div style={{ marginTop: 40, fontSize: 18, color: '#333' }}>
          Déclaration de problèmes de connexion - Transdev
        </div>
      </div>
    </>
  );
};

export default DeclarationsPbTransdev;
